<template>
  <div v-show="loading"> 
 	  <el-skeleton :rows="10" animated />
  </div>
  <!--begin::Unilevel History-->
  <div :class="widgetClasses" class="card" v-show="!loading">

    <!--begin::Body-->
    <div class="card-body py-3">
      <div class="row">
          <div class="col-lg-5">
            <div class="row mt-5">
              <div class="col-lg-4 mb-3">
                <input type="text" class="form-control form-control-lg form-control-solid mb-2" placeholder="year" name="year" readonly v-model="year">
              </div>
              <div class="col-lg-6">
                <select class="form-select form-select-solid form-select-lg fw-bold mb-2" name="month" v-model="month">
                  <option value="1">January</option>
                  <option value="2">February</option>
                  <option value="3">March</option>
                  <option value="4">April</option>
                  <option value="5">May</option>
                  <option value="6">June</option>
                  <option value="7">July</option>
                  <option value="8">August</option>
                  <option value="9">September</option>
                  <option value="10">October</option>
                  <option value="11">November</option>
                  <option value="12">December</option>
                  </select>
              </div>
              <div class="col-lg-2 text-center mb-1">
                <button
                type="submit"
                class="btn btn-primary er fs-4 px-8 py-2 mt-1 mb-1"
                v-on:click="loadUPPSummary()">
                <span class="indicator-label">
                    View
                  </span>
                  <span class="indicator-progress">
                    Please wait...
                    <span
                      class="spinner-border spinner-border-sm align-middle ms-2"
                    ></span>
                  </span>
                </button>
              </div>
            </div>
          </div>
          <div class="col-lg-3"></div>
          <div class="col-lg-4">
            <!--begin::Stat-->
                <div
                  class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 mt-5"
                >
                  <!--begin::Number-->
                  <div class="d-flex align-items-center">
                    <span class="svg-icon svg-icon-success me-2"> 
                    </span>
                    <div
                      class="fs-2 fw-bolder"
                      data-kt-countup="true"
                      data-kt-countup-value="4500"
                      data-kt-countup-prefix="$"
                    >
                      <p class="mb-0 dashboardFontStyle" id="totalcom">{{numberWithCommas(totalcom.toFixed(2))}}</p>
                    </div>
                  </div>
                  <!--end::Number-->

                  <!--begin::Label-->
                  <div class="fw-bold fs-6 text-gray-400">&nbsp;&nbsp;YOUR TOTAL UPP EARNINGS FOR THIS MONTH</div>
                  <!--end::Label-->
                </div>
                <!--end::Stat-->
          </div>
      </div>
      
      <div class="row col-lg-12">
        <div class="col-lg-8">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                  <h3 class="card-label">UPP HISTORY</h3>
              </div>
            </div>
            <div class="card-body">
              <!--begin::Table container-->
              <div class="table-responsive">
                <!--begin::Table-->
                <table class="table table-head-custom table-vertical-center table-head-bg table-borderless">
                  <!--begin::Table head-->
                  <thead>		
                    <tr class="fw-bolder text-muted bg-light">
                      <th class="ps-4 min-w-50px rounded-start">Ref. #</th>
                      <th class="min-w-100px">Business Partner</th>
                      <th class="min-w-50px">Product/Date</th>
                      <th class="min-w-50px">Commission</th>
                    </tr>
                  </thead>
                  <!--end::Table head-->
                  <!--begin::Table body-->
                  <tbody>
                    <template v-for="(item, index) in list" :key="index">
                      <tr>
                        <td>
                          <div class="d-flex align-items-center">
                            <div class="col-md-12" align="center">
                              <a class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">&nbsp;</a>
                              <span class="text-muted font-weight-bold d-block">{{index + 1}}</span>
                            </div>
                          </div>
                          </td>
                        <td class="pl-0 pt-8">
                          <div class="d-flex align-items-center">
                            <div>
                              <a class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">{{item.fullname.toUpperCase()}}</a>
                              <span class="text-muted font-weight-bold d-block">{{item.rusid}}</span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <div>
                              <a class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">{{item.prod}}</a>
                              <span class="text-muted font-weight-bold d-block">{{item.txndte}}</span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <div>
                              <span class="text-muted font-weight-bold d-block">Level:&nbsp;&nbsp;&nbsp;&nbsp;<a class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">{{item.complvl}}</a></span>
                              <span class="text-muted font-weight-bold d-block">Value:&nbsp;&nbsp;&nbsp;<a class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">{{numberWithCommas(item.compv)}}</a></span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </template> 
                  </tbody>
                  <!--end::Table body-->
                </table>
                <!--end::Table-->
              </div>
              <!--end::Table container-->
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card">
              <div class="card-header">
                <div class="card-title">
                    <h3 class="card-label">UPP EARNINGS SUMMARY FOR THIS MONTH</h3>
                </div>
              </div>
              <div class="card-body">
                <!--begin::Table container-->
                <div class="table-responsive">
                  <!--begin::Table-->
                  <table class="table align-middle gs-0 gy-4">
                    <!--begin::Table head-->
                    <thead>		
                      <tr class="fw-bolder text-muted bg-light">
                        <th class="ps-4 min-w-200px rounded-start">Level</th>
                        <th class="min-w-200px">Total</th>
                      </tr>
                    </thead>
                    <!--end::Table head-->
                    <!--begin::Table body-->
                    <tbody>
                      <template v-for="(item, index) in list2" :key="index">
                        <tr>
                          <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{item.complvl}}</td>
                          <td>{{numberWithCommas(item.total)}}</td>
                          <!-- <td sytle="display:none;">{{totalcom = parseFloat(totalcom) + parseFloat(item.total)}}</td> -->
                           
                        </tr>
                      </template> 
                    </tbody>
                    <!--end::Table body-->
                  </table>
                  <!--end::Table-->
                </div>
                <!--end::Table container-->
              </div>
            </div>
        </div>
      </div>
    </div>
    <!--begin::Body-->
     <pagination :pagination="pagination" :callback="reorderhistory" :options="paginationOptions"></pagination>
  </div>
  <!--end::Unilevel History-->
</template>

<script lang="ts">
import { defineComponent } from "vue";
import {loadUPP_summary}  from "@/api/upp";

export default defineComponent({
  name: "unilevelhistory", 
  methods: {
    async getThisMonthAndYear(){
      var d = new Date();
      var m = d.getMonth();
      var y = d.getFullYear();
      this.month = m + 1;
      this.year = y;
    },  
    async loadUPPSummary(){
      this.loading = true;
      this.totalcom = parseFloat("0.00");
      var params = {
        "month" : this.month,
        "year" : this.year
      }
      const response = await loadUPP_summary(params);
      console.log(response);
      this.list = response.data.pageList;
      this.list2 = response.data.pageList2;

      response.data.pageList2.forEach(element => {
        this.totalcom = this.totalcom + parseFloat(element.total);
      });
      this.loading = false;
    },
  },
  mounted(){
      this.getThisMonthAndYear();
      this.loadUPPSummary();
  },
  data(){
      return {
        month:0,
        year: 0,
        list : [],
        list2 : [],
        totalcom : 0.00,
        loading: true,
      }
  },
  components: {
  },
  props: {
    widgetClasses: String
  }
});

</script>
